module.exports = {"441523100":"河田镇","441523101":"水唇镇","441523102":"河口镇","441523103":"新田镇","441523104":"上护镇","441523105":"螺溪镇","441523106":"东坑镇","441523107":"南万镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441523.json
// module id = 1860
// module chunks = 0